import React from 'react'

import "./aboutus.css"
import { useState } from 'react'
// import { RiArrowDownSLine } from 'react-icons/ri';

export default function AboutUs() {

  const [background, setBackground] = useState(false)

  const changeBackground = () => {
    if (window.scrollY >= 100) {
      setBackground(true)
    } else {
      setBackground(false)
    }
  }


  window.addEventListener('scroll', changeBackground)
  return (
    <div className='emas__aboutus'>
      <div className={background ? 'emas__aboutus-header' : 'emas__aboutus-non emas__aboutus-header'}>
        <div className='emas__aboutus-header_scroll'>
          <h1>About Us</h1>
          <p> Electricity Market Advisory Services provides modelling services for clients participating in the increasingly complex electricity sector </p>
          {/* <div className='emas__aboutus-header_svg'>
            <RiArrowDownSLine size={120} color={'white'} onClick={() => contentRef.current.scrollIntoView({ behavior: "smooth" })}/>
          </div> */}
        </div>
      </div>
    </div>
  )
}
